// extracted by mini-css-extract-plugin
export default {"container":"ButtonFooter_container__MAxYx","cancelBtnMobile":"ButtonFooter_cancelBtnMobile__D1Xts","note":"ButtonFooter_note__qalO5"};